import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { Calendar, Bell } from 'lucide-react';

export default function NewsPage() {
  const news = [
    { title: 'Annual Sports Day - March 15, 2026', date: 'March 1, 2026', category: 'Event', priority: 'high' },
    { title: '96% Board Result Achievement!', date: 'February 25, 2026', category: 'Achievement', priority: 'high' },
    { title: 'New Computer Lab Inaugurated', date: 'February 20, 2026', category: 'News', priority: 'normal' },
    { title: 'PTM Scheduled - March 20, 2026', date: 'February 15, 2026', category: 'Event', priority: 'normal' },
    { title: 'Scholarship Program Applications Open', date: 'February 10, 2026', category: 'News', priority: 'high' }
  ];

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">News & Announcements</h1>
          <p className="text-xl text-blue-100">Stay updated with latest school news</p>
        </div>
      </section>
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-6">
            {news.map((item, i) => (
              <GlassCard key={i} className="hover:shadow-2xl transition-shadow">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <Bell className={`w-5 h-5 ${item.priority === 'high' ? 'text-red-500' : 'text-blue-500'}`} />
                      <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
                        item.category === 'Event' ? 'bg-purple-100 text-purple-700' :
                        item.category === 'Achievement' ? 'bg-green-100 text-green-700' :
                        'bg-blue-100 text-blue-700'
                      }`}>
                        {item.category}
                      </span>
                      {item.priority === 'high' && (
                        <span className="px-3 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded-full">
                          Important
                        </span>
                      )}
                    </div>
                    <h3 className="text-xl font-bold text-blue-900 mb-2">{item.title}</h3>
                    <div className="flex items-center text-slate-600 text-sm">
                      <Calendar className="w-4 h-4 mr-2" />
                      {item.date}
                    </div>
                  </div>
                </div>
              </GlassCard>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
